"use strict";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isObject;
function isObject(value) {
    return _instanceof(value, Object) && !Array.isArray(value);
}
